import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { bpitLog, log } from '../../utils';
import { compareVersions } from '../../utils/compareVersions';
import packageInfo from '../../../package.json';
var Sdk = /*#__PURE__*/function () {
  function Sdk(env) {
    var _this = this;
    _classCallCheck(this, Sdk);
    this.invokeAPIConfigMapByMethod = {};
    this.configJsApiList = [];
    this.platformConfigMap = {};
    this.hadConfig = false;
    this.bridgeInitFnPromise = null;
    this.cacheP = {};
    this.config$ = new _Promise(function (a, b) {
      _this.cacheP.resolve = a;
      _this.cacheP.reject = b;
    });
    this.env = env;
    this.exportSdk = {
      version: env.version,
      sdkVersion: packageInfo.version,
      // sdkVersion: '0.0.0',
      env: env,
      platform: env.platform,
      platformV2: env.platformV2,
      config: function config() {
        var _config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // 鉴权
        var _config$jsApiList = _config.jsApiList,
          jsApiList = _config$jsApiList === void 0 ? [] : _config$jsApiList;
        if (_this.hadConfig) {
          console.log('Config has been executed');
        } else {
          _this.bridgeInitFn().then(function (fn) {
            fn('config', _config).then(function (value) {
              // 鉴权成功
              _this.cacheP.resolve(value);
              _this.hadConfig = true;
              _this.configJsApiList = jsApiList;
            })["catch"](function (error) {
              // 后台鉴权失败
              _this.cacheP.reject(error);
            });
          });
        }
      },
      ready: function ready(fn) {
        _this.bridgeInitFn().then(function () {
          fn();
        });
      },
      error: function error(fn) {
        _this.config$["catch"](function (error) {
          fn(error);
        });
      },
      on: function on(o, n) {
        _this.bridgeInitFn().then(function () {
          _this.platformConfigMap[env.platform].event.on(o, n);
        });
      },
      off: function off(o, n) {
        _this.bridgeInitFn().then(function () {
          _this.platformConfigMap[env.platform].event.off(o, n);
        });
      }
    };
  }
  _createClass(Sdk, [{
    key: "setAPI",
    value: function setAPI(method, config) {
      this.invokeAPIConfigMapByMethod[method] = config;
    }
    // 确定端的同事初始化bridge
  }, {
    key: "setPlatform",
    value: function setPlatform(value) {
      var platform = value.platform,
        bridgeInit = value.bridgeInit;
      this.platformConfigMap[platform] = value;
      // if (this.env.platform === platform) bridgeInit();
    }
  }, {
    key: "bridgeInitFn",
    value: function bridgeInitFn() {
      // 平台环境不对再调用api就肯定失败
      if (this.bridgeInitFnPromise) {
        return this.bridgeInitFnPromise;
      }
      var o = this.platformConfigMap[this.env.platform];
      if (o) {
        this.bridgeInitFnPromise = o.bridgeInit();
      } else {
        var n = 'Do not support the current environment�' + this.env.platform;
        this.bridgeInitFnPromise = _Promise.reject(new Error(n));
      }
      return this.bridgeInitFnPromise;
    }
  }, {
    key: "_onFail",
    value: function _onFail(method, errorcode, message, onFail) {
      bpitLog({
        method: method,
        errorcode: errorcode,
        message: message
      });
      onFail && typeof onFail == 'function' && onFail({
        code: errorcode,
        message: message
      });
    }
  }, {
    key: "invokeAPI",
    value: function invokeAPI(method, params) {
      var _context2;
      if (!params) params = {};
      if (!method) return;
      // 验证方法是否可用
      var apiConfigs = this.invokeAPIConfigMapByMethod[method];
      if (!apiConfigs) {
        return this._onFail(method, '-1', "[".concat(method, "] method is not exist"), params.onFail);
      }
      var apiConfig = apiConfigs[this.env.platform];
      if (apiConfig) {
        var supportVersion = apiConfig.vs || '0.0.0';
        if (compareVersions(this.env.version, supportVersion) < 0) {
          var _context;
          return this._onFail(method, '-1', _concatInstanceProperty(_context = "The current application version is ".concat(this.env.version, ". This method does not support versions less than ")).call(_context, supportVersion), params.onFail);
        }
        // 确定参数
        var p = apiConfig.paramsDeal ? apiConfig.paramsDeal(params) : params;
        // 确定回调
        if ('function' == typeof p.onSuccess) {
          var v = p.onSuccess;
          p.onSuccess = function (e) {
            v(e);
          };
        }
        // 主方法
        this.bridgeInitFn().then(function (fn) {
          fn(method, p).then(function (res) {
            // 调用成功
            log("SDK \u8FD4\u56DE\u7ED3\u679C\u6210\u529F ", {
              method: method,
              params: p,
              result: res
            });
          })["catch"](function (error) {
            // 调用失败
            log("SDK \u8FD4\u56DE\u7ED3\u679C\u5931\u8D25", {
              method: method,
              params: p,
              error: error
            });
          });
        })["catch"](function (err) {
          console.log('wenai err', err);
        });
        return;
      }
      this._onFail(method, '-1', _concatInstanceProperty(_context2 = "[".concat(method, "] method do not support the current platform (")).call(_context2, this.env.platform, ")"), params.onFail);
    }
  }]);
  return Sdk;
}();
export default Sdk;


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/lib/sdk/index.js
// module id = null
// module chunks = 